import { Table } from '@tanstack/react-table';
import { TablePagination } from '../../compound/tables/presentation/table/pagination';

function Pagination<T>({ table }: Readonly<{ table: Table<T> }>) {
  const pagination = table.getState().pagination;
  const setPagination = table.setPagination;

  return (
    <TablePagination
      count={table.getRowCount()}
      page={pagination.pageIndex}
      onPageChange={(_, page) => setPagination({ ...pagination, pageIndex: page })}
      rowsPerPage={pagination.pageSize}
      onRowsPerPageChange={(event) =>
        setPagination({
          pageSize: Number(event.target.value),
          pageIndex: 0
        })
      }
    />
  );
}

export default Pagination;
